// 简化版权限服务 - 避免循环依赖
export class SimplePermissionService {
  // 权限定义
  static PERMISSIONS = {
    STORY_CREATE: 'story:create',
    STORY_READ: 'story:read',
    STORY_UPDATE: 'story:update',
    STORY_DELETE: 'story:delete',
    STORY_PUBLISH: 'story:publish',
    STORY_SHARE: 'story:share',
    MEDIA_UPLOAD: 'media:upload',
    MEDIA_READ: 'media:read',
    MEDIA_DELETE: 'media:delete',
    MEDIA_MANAGE: 'media:manage',
    PROFILE_UPDATE: 'profile:update',
    PROFILE_READ: 'profile:read',
    PASSWORD_CHANGE: 'password:change',
    SYSTEM_ADMIN: 'system:admin',
    USER_MANAGE: 'user:manage',
    CONTENT_MODERATE: 'content:moderate',
    ANALYTICS_VIEW: 'analytics:view'
  }

  // 角色定义
  static ROLES = {
    GUEST: 'guest',
    USER: 'user',
    MODERATOR: 'moderator',
    ADMIN: 'admin',
    SUPER_ADMIN: 'super_admin'
  }

  // 角色权限映射
  static ROLE_PERMISSIONS = {
    guest: ['story:read'],
    user: [
      'story:create', 'story:read', 'story:update', 'story:delete',
      'story:publish', 'story:share', 'media:upload', 'media:read',
      'media:delete', 'profile:update', 'profile:read', 'password:change'
    ],
    moderator: [
      'story:create', 'story:read', 'story:update', 'story:delete',
      'story:publish', 'story:share', 'media:upload', 'media:read',
      'media:delete', 'profile:update', 'profile:read', 'password:change',
      'content:moderate', 'analytics:view'
    ],
    admin: [
      'story:create', 'story:read', 'story:update', 'story:delete',
      'story:publish', 'story:share', 'media:upload', 'media:read',
      'media:delete', 'profile:update', 'profile:read', 'password:change',
      'content:moderate', 'analytics:view', 'user:manage', 'system:admin'
    ],
    super_admin: [
      'story:create', 'story:read', 'story:update', 'story:delete',
      'story:publish', 'story:share', 'media:upload', 'media:read',
      'media:delete', 'profile:update', 'profile:read', 'password:change',
      'content:moderate', 'analytics:view', 'user:manage', 'system:admin'
    ]
  }

  /**
   * 检查用户是否有指定权限
   * @param {string} permission - 权限名称
   * @param {Object} user - 用户对象
   * @returns {boolean} 是否有权限
   */
  static hasPermission(permission, user = null) {
    if (!user) return false
    if (!user.isActive) return false

    // 检查用户权限列表
    if (user.permissions && user.permissions.includes(permission)) {
      return true
    }

    // 检查角色权限
    const rolePermissions = this.ROLE_PERMISSIONS[user.role] || []
    return rolePermissions.includes(permission)
  }

  /**
   * 检查用户是否有指定角色
   * @param {string} role - 角色名称
   * @param {Object} user - 用户对象
   * @returns {boolean} 是否有该角色
   */
  static hasRole(role, user = null) {
    if (!user) return false
    return user.role === role
  }

  /**
   * 获取用户的所有权限
   * @param {Object} user - 用户对象
   * @returns {Array} 权限列表
   */
  static getUserPermissions(user = null) {
    if (!user) return []

    const userPermissions = user.permissions || []
    const rolePermissions = this.ROLE_PERMISSIONS[user.role] || []
    
    return [...new Set([...userPermissions, ...rolePermissions])]
  }
}

export default SimplePermissionService

